import React from 'react';
import t from '@jetshop/intl';
import { styled } from 'linaria/react';
import {
  DropdownMenu,
  DropdownMenuButton,
  DropdownMenuItem,
  DropdownMenuItems
} from '@jetshop/ui/DropdownMenu';
import { ReactComponent as Caret } from '../../../svg/Caret.svg';
import Image from '@jetshop/ui/Image';
import { VariantHeading } from './VariantButtons';
import { theme } from '../../Theming/Theming';
import { stockStatusMask } from '../StockStatus/StockStatusIndicator';

export const DropdownWrapper = styled('div')`
  margin-bottom: 1rem;
  [data-flight-dropdown] {
    background: white;
    [data-flight-dropdown-button] {
      background: white;
      width: 100%;
      display: flex;
      align-items: center;
      height: 60px;
      border: 1px solid ${theme.colors.borderInput};
      border-radius: 0 !important;
      justify-content: space-between;
      svg {
        transition: all 200ms;
      }
    }
    &[data-flight-dropdown-open='true'] {
      [data-flight-dropdown-button] {
        svg {
          transform: rotate(-180deg);
        }
      }
    }
    [data-flight-dropdown-items] {
      position: static;
      width: 100%;
      border: 1px solid ${theme.colors.borderInput};
      margin-top: -1px;
    }
    [data-flight-dropdown-item] {
      height: 60px;
      display: flex;
      align-items: center;
      border-top: 1px solid ${theme.colors.borderLight};
      padding: 4px 1rem;
      &:hover {
        background: ${theme.colors.greys[0]};
        color: inherit;
      }
      &:focus,
      &:hover {
        outline: none;
      }
      &.selected {
        background: ${theme.colors.greys[1]};
        p {
          font-weight: ${theme.weights.bold};
        }
      }
    }
  }
  &.invalid [data-flight-dropdown-button] {
    box-shadow: 0 0 10px rgba(195, 45, 45, 0.38);
  }
`;

export const VariantWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const VariantInfo = styled('div')`
  display: flex;
  align-items: center;
`;

export const VariantImage = styled('div')`
  width: 60px;
  margin-right: 15px;
`;

export const VariantName = styled('span')``;

export const VariantStock = styled('div')`
  color: ${theme.colors.outOfStock};
  &.buyable {
    color: ${theme.colors.inStock};
  }
`;

const VariantDropdown = ({
  option,
  variantHandler,
  showValidationMessage,
  showImages = true
}) => {
  const {
    getSelectedValue,
    validateSelection,
    selectValue,
    getVariantForSelection
  } = variantHandler;
  const selectedValue = getSelectedValue(option);
  return (
    <DropdownWrapper className={showValidationMessage ? 'invalid' : null}>
      <VariantHeading>{option.name}</VariantHeading>
      <DropdownMenu>
        <DropdownMenuButton id={`dropdown-option-${option.name}`}>
          {selectedValue ? selectedValue : t('Choose')}
          <Caret />
        </DropdownMenuButton>
        <DropdownMenuItems>
          {option.values.map(value => {
            const validation = validateSelection(value, option);
            const variant = getVariantForSelection(value, option);
            return (
              <DropdownMenuItem
                className={selectedValue === value ? 'selected' : null}
                key={value + option.name}
                disabled={validation === 'invalid'}
                onSelect={({ setIsOpen }) => {
                  selectValue(value, option);
                  setIsOpen(false);
                }}
                style={{ opacity: validation === 'invalid' ? 0.5 : 1 }}
              >
                <VariantWrapper>
                  <VariantInfo>
                    {showImages &&
                      variant &&
                      variant.images &&
                      variant.images.length > 0 && (
                        <VariantImage>
                          <Image
                            src={variant.images[0].url}
                            sizes={[60]}
                            aspect="1:1"
                            crop={false}
                          />
                        </VariantImage>
                      )}
                    <VariantName>{value}</VariantName>
                  </VariantInfo>
                  <VariantStock
                    className={
                      variant && variant.stockStatus.buyable ? 'buyable' : null
                    }
                  >
                    {variant && stockStatusMask(variant.stockStatus.text)}
                  </VariantStock>
                </VariantWrapper>
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuItems>
      </DropdownMenu>
    </DropdownWrapper>
  );
};

export default VariantDropdown;
